<template>
  <v-layout wrap>
    <v-flex xs12>
      <SettingsUsersCard
        v-bind="{
          currentUser,
          users,
          saveUserPermission,
          removeUserPermission,
          resendInvitation
        }"
      />
    </v-flex>
    <v-flex xs12>
      <SettingsSpaceCard
        v-bind="{ space: currentSpace, deleteSpace, updateSpace, isOwner }"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import SettingsUsersCard from "@/components/SettingsUsersCard.vue";
import SettingsSpaceCard from "@/components/SettingsSpaceCard.vue";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    SettingsUsersCard,
    SettingsSpaceCard
  },
  computed: {
    ...mapGetters(["currentUser", "isOwner"]),
    ...mapState("spaces", { spaces: "content" }),
    ...mapGetters("spaces", { currentSpace: "active" }),
    ...mapGetters("users", ["userBySpace"]),
    users() {
      return this.currentSpace ? this.userBySpace(this.currentSpace) : [];
    }
  },
  methods: {
    saveUserPermission(user) {
      return this.$store.dispatch("invites/save", {
        space_id: this.currentSpace.id,
        ...user
      });
    },
    removeUserPermission(user) {
      return this.$store.dispatch("updateResource", {
        parent: {
          type: "spaces",
          id: this.currentSpace.id
        },
        pathName: "revoke",
        type: `${user.type}s`,
        id: user.id
      });
    },
    async deleteSpace() {
      const spaceId = this.currentSpace.id;
      await this.$store.dispatch("spaces/delete", spaceId);
      this.$store.commit("removeSpace", spaceId);
      this.$router.push(`/spaces`);
    },
    updateSpace(name) {
      return this.$store.dispatch("spaces/save", {
        id: this.currentSpace.id,
        name
      });
    },
    resendInvitation(user) {
      return this.$store.dispatch("users/resendInvite", {
        space_id: this.currentSpace.id,
        ...user
      });
    }
  }
};
</script>
